import {Question} from "./QuestionAnswerComponent.tsx";
import {Link} from "react-router-dom";
import {imageMap} from "../../images/imageMap.ts";
import Routing from "../../Routing.ts";

export const WhatConnectionType: Question = {
    question: "Er du i tvivl om, hvilken forbindelse du har?",
    answer: <>
        <p>Du kan se din forbindelse under <strong>Mit Abonnement</strong> i <Link to={Routing.Selfcare.Account}>Mit Hiper</Link>.</p>
        <img
            className={'box-shadow hide-on-large-devices'}
            src={imageMap.help.what_product.mobile}
            alt={'Grafik der viser hvor du kan finde dit produkt i &ldquo;Profil&rdquo;.'}
        />
        <img
            className={'box-shadow hide-on-small-devices'}
            src={imageMap.help.what_product.desktop}
            alt={'Grafik der viser hvor du kan finde dit produkt i &ldquo;Profil&rdquo;.'}
        />
    </>
};

export const WhatRouter: Question = {
    question: "Ved du ikke, hvilken router du har?",
    answer: <>
        <p>Du kan se din router under <strong>Udstyr</strong> på <Link to={Routing.Selfcare.Internet}>Internet-siden i Mit Hiper</Link>.</p>
        <img
            className={'box-shadow hide-on-large-devices'}
            src={imageMap.help.choose_router.what_router_mobile}
            alt={'Grafik der viser hvor du kan finde din router i &ldquo;Udstyr&rdquo;.'}
        />
        <img
            className={'box-shadow hide-on-small-devices'}
            src={imageMap.help.choose_router.what_router_desktop}
            alt={'Grafik der viser hvor du kan finde din router i &ldquo;Udstyr&rdquo;.'}
        />
    </>
};
